var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_1418645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_1418645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_1418645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.23349 28.1332C3.63349 28.1332 3.19438 27.8835 2.91616 27.3839C2.63882 26.8835 2.6446 26.3777 2.93349 25.8666L15.1668 4.66657C15.4557 4.15546 15.9002 3.8999 16.5002 3.8999C17.1002 3.8999 17.5446 4.15546 17.8335 4.66657L30.0668 25.8666C30.3557 26.3777 30.3615 26.8835 30.0842 27.3839C29.8059 27.8835 29.3668 28.1332 28.7668 28.1332H4.23349ZM16.5002 13.4332C16.1224 13.4332 15.8059 13.5608 15.5508 13.8159C15.2948 14.0719 15.1668 14.3888 15.1668 14.7666V18.6666C15.1668 19.0443 15.2948 19.3608 15.5508 19.6159C15.8059 19.8719 16.1224 19.9999 16.5002 19.9999C16.8779 19.9999 17.1948 19.8719 17.4508 19.6159C17.7059 19.3608 17.8335 19.0443 17.8335 18.6666V14.7666C17.8335 14.3888 17.7059 14.0719 17.4508 13.8159C17.1948 13.5608 16.8779 13.4332 16.5002 13.4332ZM16.5002 23.9666C16.8779 23.9666 17.2002 23.8332 17.4668 23.5666C17.7335 23.2999 17.8668 22.9777 17.8668 22.5999C17.8668 22.2221 17.7335 21.8999 17.4668 21.6332C17.2002 21.3666 16.8779 21.2332 16.5002 21.2332C16.1224 21.2332 15.8002 21.3666 15.5335 21.6332C15.2668 21.8999 15.1335 22.2221 15.1335 22.5999C15.1335 22.9777 15.2668 23.2999 15.5335 23.5666C15.8002 23.8332 16.1224 23.9666 16.5002 23.9666ZM6.63349 25.2332H26.3668L16.5002 8.23324L6.63349 25.2332Z",
    fill: "url(#paint0_linear_116_1418645)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_1418645",
    x1: 3.83033,
    y1: 3.89991,
    x2: 36.4198,
    y2: 6.2304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_1418645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.13f66d45c29645bf53c6b3a617eb8a8b.svg";
export { ForwardRef as ReactComponent };